import React, { useContext, useMemo } from 'react';

import { TicketBubble } from '@components/admin/booking/TicketBubble';
import { CustomsInstructionContext } from '@components/utilities/Bookings/helpers2';
import { companyStrings } from '@data/company';
import { useZendeskD2dTickets } from '@hooks/queries/dashboard/useZendeskD2dTickets';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';
import { mapOptional } from '@utils/types';
import clsx from 'clsx';
import { stringify } from 'query-string';

const strings = createStrings({
  ja: {
    title: 'CNEE情報',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  customsInstructionConsigneeDisplayContainer: {},
  customsInstructionConsigneeDisplayInfo: {
    ...common.textBlack,
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    columnGap: '0.5rem',
    rowGap: '0.5rem',
    '& > div': {
      wordBreak: 'break-all',
    },
  },
  customsInstructionConsigneeDisplayTitle: {
    ...common.flexInline,
    ...common.justifyBetween,
    ...common.itemsCenter,
    marginBottom: '0.5rem',
  },
}));

export const CustomsInstructionConsigneeDisplay: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { d2dNo, baseInquiryDetail } = useContext(CustomsInstructionContext);

  const zendeskTickets = useZendeskD2dTickets(d2dNo);

  const consigneeId = useMemo(() => baseInquiryDetail?.consignee?.user, [baseInquiryDetail]);

  const consigneeEmail = baseInquiryDetail?.consignee?.email;

  const ticket = useMemo(() => {
    return zendeskTickets.data?.find((ticket) => ticket.requester.email === consigneeEmail);
  }, [zendeskTickets.data]);

  return (
    <div className={classes.customsInstructionConsigneeDisplayContainer}>
      <div className={classes.customsInstructionConsigneeDisplayTitle}>
        <span className={clsx(classes.textBlack, classes.normalText, classes.fontWeight600)}>
          {strings.title}
        </span>

        {zendeskTickets.isSuccess && consigneeId && (
          <TicketBubble userId={consigneeId} d2dNo={d2dNo} ticket={ticket} />
        )}
      </div>

      <div className={classes.customsInstructionConsigneeDisplayInfo}>
        <div>{companyStrings.company_name}</div>
        <div>
          {consigneeId ? (
            <a
              className={classes.link}
              href={
                url('/admin/members/MemberDetails') +
                '?' +
                stringify({ id: baseInquiryDetail?.consignee?.user! })
              }
              target="_blank"
            >
              {baseInquiryDetail?.consignee?.company_name}
            </a>
          ) : (
            baseInquiryDetail?.consignee?.company_name
          )}

          <br />

          <span className={classes.textGray500}>{baseInquiryDetail?.consignee?.english_name}</span>
        </div>

        <div>{companyStrings.principal}</div>

        <div>{baseInquiryDetail?.consignee?.principal_name}</div>

        <div>{companyStrings.email}</div>

        <div>
          {mapOptional(baseInquiryDetail?.consignee?.email, (email) => (
            <a href={`mailto:${email}`} className={classes.link} target="_blank">
              {email}
            </a>
          )) || '-'}
        </div>
      </div>
    </div>
  );
};
